import React, { FC } from 'react';
import {
    KintekiFullComponent,
    KintekiSemiComponent,
    EntekiFullComponent,
    EntekiSemiComponent,
    MaikiwaraFullComponent,
} from '@component/PartsSelect';
import { useOrderPathParams } from '@app/react/contexts/useOrderPathParams';

interface PartsNaviContainerProps {
    visible: boolean;
    enablePreviewMode: boolean;
}

export const PartsNaviContainer: FC<PartsNaviContainerProps> = (props) => {
    const { visible, enablePreviewMode } = props;
    const { arrowType, orderType } = useOrderPathParams();

    if (arrowType === 'kinteki' && orderType === 'full') {
        return (
            <KintekiFullComponent
                visible={visible}
                enablePreviewMode={enablePreviewMode}
            />
        );
    }
    if (arrowType === 'kinteki' && orderType === 'semi') {
        return (
            <KintekiSemiComponent
                visible={visible}
                enablePreviewMode={enablePreviewMode}
            />
        );
    }
    if (arrowType === 'enteki' && orderType === 'full') {
        return (
            <EntekiFullComponent
                visible={visible}
                enablePreviewMode={enablePreviewMode}
            />
        );
    }
    if (arrowType === 'enteki' && orderType === 'semi') {
        return (
            <EntekiSemiComponent
                visible={visible}
                enablePreviewMode={enablePreviewMode}
            />
        );
    }
    if (arrowType === 'makiwara' && orderType === 'full') {
        return (
            <MaikiwaraFullComponent
                visible={visible}
                enablePreviewMode={enablePreviewMode}
            />
        );
    }

    return null;
};
